import { Injectable } from '@angular/core';
import { BehaviorSubject, concatMap, Observable, of } from 'rxjs';
import { User } from './shared.types';
import { APIService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private _user: BehaviorSubject<User> = new BehaviorSubject<User>(null);

  /**
   * Constructor
   */
  constructor(private _apiService: APIService) {}

  // -----------------------------------------------------------------------------------------------------
  // @ Accessors
  // -----------------------------------------------------------------------------------------------------

  /**
   * Setter & getter for user
   *
   * @param value
   */

  get user$(): Observable<User> {
    if (this._user.value) {
      return this._user.asObservable();
    } else {
      return this.get();
    }
  }

  set user(value: User) {
    // Store the value
    this._user.next(value);
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Get the current logged in user data
   */
  get(): Observable<any> {
    let user;
    return this._apiService.get('auth/me', null).pipe(
      concatMap((userResponse: any): any => {
        user = userResponse.data;
        return of(user);
      })
    );
  }

  /**
   * Update the user
   *
   * @param user
   */
  update(user: User): void {
    this._user.next(user);
  }
}
